module.exports = __webpack_public_path__ + "static/media/297401.530dea73.png";